// Coffeescript transformed to Javascript via https://awsm-tools.com/code/coffee2js
// See: http://getcontenttools.com/tutorials/adding-new-tools

import ContentTools from 'ContentTools/build/content-tools.min.js';
import { coffeeExtends } from './helpers';

export const initContractLink = function () {
    (function (_super) {
        coffeeExtends(ContractLink, _super);
        function ContractLink() {
            return ContractLink.__super__.constructor.apply(this, arguments);
        }
        ContentTools.ToolShelf.stow(ContractLink, 'contractlink');
        ContractLink.label = 'Insert Contract Link';
        ContractLink.icon = 'contractlink';
        ContractLink.tagName = 'cli';
        ContractLink.apply = (element, selection, callback) => {
            const cursor = selection.get()[0] + 1;

            const tip = element.content.substring(0, selection.get()[0]);
            const tail = element.content.substring(selection.get()[1]);
            const cliHtml = `[CONTRACT_LINK]`;
            // http://getcontenttools.com/api/html-string
            element.content = tip.concat(
                new window.HTMLString.String('', true),
                cliHtml,
                new window.HTMLString.String('', true),
                tail,
                false
            );
            element.updateInnerHTML();
            element.taint();

            // Restore the selection
            selection.set(cursor + 12, cursor + 12);
            element.selection(selection);
            ContentTools.Tools.LineBreak.dispatchEditorEvent('tool-applied', {
                name: 'CKP_ContractLink',
                transform: true
            });
            callback(true);
        };
        return ContractLink;
    })(ContentTools.Tools.LineBreak);
};
